import {
  Component,
  ChangeDetectionStrategy,
  signal,
  computed,
  inject,
  OnInit,
} from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { SidebarComponent } from './core/layout/components/sidebar/sidebar.component';
import { ToolbarComponent } from './core/layout/components/toolbar/toolbar.component';
import { FooterComponent } from './core/layout/components/footer/footer.component';
import { PrototypeBannerComponent } from './shared/components/prototype-banner/prototype-banner.component';
import { STAGES } from './core/layout/components/sidebar/sidebar.model';

/**
 * AppComponent — Root application shell layout host.
 *
 * Sidebar collapse/expand is deferred to a future story.
 */
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    SidebarComponent,
    ToolbarComponent,
    FooterComponent,
    PrototypeBannerComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  private readonly liveAnnouncer = inject(LiveAnnouncer);
  private readonly router = inject(Router);

  activeStageIndex = signal<number>(0);

  pageTitle = computed(() => STAGES[this.activeStageIndex()].name);

  ngOnInit(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.liveAnnouncer.announce(`Navigated to ${this.pageTitle()}`);
      });
  }

  onStageSelected(index: number): void {
    this.activeStageIndex.set(index);
  }
}
